import axios from 'axios';
const API_URL = process.env.VUE_APP_API_URL + "me";

class UserService {
  async me(token) {
    try {
        let config = {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }
      const response = await axios
        .get(API_URL, config);
      return response?.data;
    } catch (e) {
      return e.response?.data;
    }
  }

  async products(token) {
    try {
        let config = {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }
      const response = await axios
      .get(API_URL + '/products', config);
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response.data);
    }
  }

  async apps(token) {
    try {
      let config = {
        headers: {
          "Authorization": `Bearer ${token}`
        }
      }
      const response = await axios
      .get(API_URL + '/apps', config);
      return response?.data;
    } catch (e) {
      return Promise.reject(e.response?.data);
    }
  }
}
export default new UserService();